import { render, staticRenderFns } from "./scoreWrapper.vue?vue&type=template&id=1a1c0133&scoped=true"
import script from "./scoreWrapper.vue?vue&type=script&lang=js"
export * from "./scoreWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c0133",
  null
  
)

export default component.exports